
import React, { useState, useEffect } from 'react';
import { Radio, Tabs } from 'antd';

import { Modal, Form, Input, Switch, Select } from 'antd';
import DaySelector from "../../GeneralComponents/DaySelector"
import styles from "./styles.module.css"
import { ButtonCustom } from '../../BootstrapComponents/ButtonCustom';
const DynamicRanges = ({ dynamicRanges, setDynamicRanges, selLocation, getUpdatedDynamicRanges,sharedFieldVisible,setLocationData }) => {
    console.log("dynamicRanges", dynamicRanges)
    // console.log(typeof(chargerDynamicRates))
    // const [chargerDynamicRatestate, setChargerDynamicRateState] = useState(chargerDynamicRates)

    const [disableEditRateField, setDisableEditRateField] = useState(false)

    const [radioValue, setRadioValue] = useState('')

    const [radioArray, setRadioArray] = useState([])

    useEffect(()=>{
        console.log("useeffect dynamic Rate")
        const updatedRadioArray = dynamicRanges.map((rate) => {
            if (JSON.stringify(rate.applicableDays) === JSON.stringify([1, 0, 0, 0, 0, 0, 1])) {
              return 'weekends'; // Set to 'weekend' if applicableDays matches
            } else if (JSON.stringify(rate.applicableDays) === JSON.stringify([0, 1, 1, 1, 1, 1, 0])) {
              return 'weekdays'; // Set to 'weekday' if applicableDays matches
            } else {
              return ''; // Fallback option
            }
          });
        console.log(updatedRadioArray)
          setRadioArray(updatedRadioArray);
        
    },[dynamicRanges])

    const convertToTimezone = (timeString, targetZone) => {
        const [start, end] = timeString.split('-');
        const getDateWithTime = (time, position) => {
            // Create a date object assuming the time is in UTC (can adjust if needed)
            const [hours, minutes, seconds] = time.split(':');
            const date = new Date();
            date.setUTCHours(hours);
            date.setUTCMinutes(minutes);
            date.setUTCSeconds(seconds);
            date.setUTCMilliseconds(position==="start" ? 0 : 999)
            return date;
        };
        const formatTime = (date, timeZone) => {
            return date.toLocaleString('en-US', {
                timeZone: timeZone,
                hour12: false,
                hour: '2-digit',
                minute: '2-digit'
            });
        };
        const startTimeDate = getDateWithTime(start, "start");
        const endTimeDate = getDateWithTime(end, "end");
        let adjustedEndTimeDate = new Date(endTimeDate.getTime()+1)
        // console.log('target zone: ',targetZone);
        // console.log('start time date: ',startTimeDate);
        // console.log('end time date: ',endTimeDate);
        const convertedStartTime = formatTime(startTimeDate, targetZone);
        const convertedEndTime = formatTime(adjustedEndTimeDate, targetZone);
        return `${convertedStartTime} - ${convertedEndTime}`;
    };


    function onSelectedDayChange(newSelectedDays, index) {

        let updatedDynamicRates = [...dynamicRanges]
        updatedDynamicRates[index].applicableDays = newSelectedDays
        setDynamicRanges(updatedDynamicRates)
        getUpdatedDynamicRanges(updatedDynamicRates)
    }

    function updateDynamicRate(updatedRate, index){
        
        let updatedDynamicRates = [...dynamicRanges]
        updatedDynamicRates[index].rate = updatedRate ? parseFloat(updatedRate) : ""
        setDynamicRanges(updatedDynamicRates)
        getUpdatedDynamicRanges(updatedDynamicRates)
    }
    function updateFreeChargingInDynamicRate(checked, index){
        console.log("checked value", checked)
        let updatedDynamicRates = [...dynamicRanges]
        updatedDynamicRates[index].freeCharging = checked
        if(checked){
            updatedDynamicRates[index].rate = 0
            setDisableEditRateField(true)
        }else{
            setDisableEditRateField(false)
        }
        setDynamicRanges(updatedDynamicRates)
        getUpdatedDynamicRanges(updatedDynamicRates)
        
    }


    const removeDynamicRate =  (id)=> {
        console.log(id)
        let updatedRateList = dynamicRanges.filter((dr) =>{
            return dr._id !== id
        })
        console.log("updatedChargerList",updatedRateList)
        setDynamicRanges(updatedRateList)

        {sharedFieldVisible && setLocationData((obj) => ({
            ...obj, 
            sharedTime: updatedRateList
        }))};
    }

    const handleRadioChange = (e, index) => {
        setRadioValue(e.target.value)
        let updatedRadioArray = [...radioArray];
        updatedRadioArray[index] = e.target.value;
        setRadioArray(updatedRadioArray)
        let newSelectedDays = []
        console.log(e.target.value)

        if (e.target.value === 'weekdays') {

            newSelectedDays = [0, 1, 1, 1, 1, 1, 0]
            console.log(newSelectedDays)
        }
        if (e.target.value === 'weekends') {
            newSelectedDays = [1, 0, 0, 0, 0, 0, 1]
            console.log(newSelectedDays)
        }
        let updatedDynamicRates = [...dynamicRanges]
        updatedDynamicRates[index].applicableDays = newSelectedDays
        console.log(updatedDynamicRates[index])
        setDynamicRanges(updatedDynamicRates)
        getUpdatedDynamicRanges(updatedDynamicRates);
    }
    console.log('charger dynamic rate: ',dynamicRanges);

    return (
        dynamicRanges && dynamicRanges.length > 0 ?
            <div>

                <Tabs
                    defaultActiveKey="0"
                    tabPosition={'top'}
                    // style={{
                    //     height: 250,
                    // }}
                    items={new Array(dynamicRanges.length).fill(null).map((_, i) => {
                        const id = String(i);
                        return {
                            label: `${convertToTimezone(dynamicRanges[i].timeRange, selLocation.timezone)}`,
                            key: id,
                            // disabled: i === 3,
                            children:  
                            <>
                                <DaySelector chargerDynamicRateApplicableDays={dynamicRanges[i].applicableDays} onSelectedDayChange={onSelectedDayChange} rateIndex={i} customDays={radioArray[i]}/>
                               {
                                !sharedFieldVisible?
                                 <Form.Item label="Rate">
                                <Input type="number" step="0.1" disabled={dynamicRanges[i].freeCharging || disableEditRateField}  value={dynamicRanges[i].rate} onChange={(e) => {updateDynamicRate(e.target.value, i)}} />
                                {/*  */}
                            </Form.Item>:
                            <div></div>
                               }
                                <div className={styles.DynamicRatesBtnCntr}>
                                    {
                                        !sharedFieldVisible?
                                        <Form.Item label="Free Charging" valuePropName="checked">
                                        <Switch
                                            disabled={true}
                                            checked={dynamicRanges[i].freeCharging}
                                            onChange={(checked) => { updateFreeChargingInDynamicRate(checked, i)}}
                                        />
                                        </Form.Item>
                                        :
                                        <div></div>
                                    }
                             
                                        <div className={styles.RadioBtnCntr}>
                                            <span>Preset Day Selection</span>
                                            <Radio.Group onChange={(e)=>{handleRadioChange(e,id)}} value={radioArray[i]} >
                                            {/* // defaultValue={JSON.stringify(chargerDynamicRate[i].applicableDays) === JSON.stringify([1, 0, 0, 0, 0, 0, 1])? 'weekends': JSON.stringify(chargerDynamicRate[i].applicableDays) === JSON.stringify([0, 1, 1, 1, 1, 0, 0])? 'weekdays':'' } */}
                                                <div className={styles.RadioBtnCntr}>
                                                    <Radio value="weekends">Weekends</Radio>
                                                    <Radio value="weekdays">Week Days</Radio>
                                                </div>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                    <Form.Item>
                                    <ButtonCustom text={"Remove"} onClick={()=>{removeDynamicRate(dynamicRanges[i]._id)}} variant={'danger'} style={{float:'right',width: '130px'}}></ButtonCustom>
                                </Form.Item>
                                <div style={{clear:'both'}}></div>
                            </>,
                        };
                    })}
                />
            </div> :
            <div className={styles.noDynamicRateDiv}> {sharedFieldVisible?'no shared time selection to show':'no dynamic rate to show' } </div>

    );
};
export default DynamicRanges;